import * as React from 'react';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

export type ConfirmationResult = 'confirmed' | 'cancelled';

export interface Props {
  title: string;
  onClose: (result: ConfirmationResult) => void;
  cancelable?: boolean;
  dangerous?: boolean;
  largeSize?: boolean;
  children?: React.ReactNode;
  okButtonText?: string;
}

class ConfirmationDialog extends React.Component<Props> {
  render() {
    const { onClose, title, children, cancelable, dangerous, largeSize, okButtonText } = this.props;
    return (
      <Dialog open={true} onClose={() => onClose(cancelable ? 'cancelled' : 'confirmed')} maxWidth={largeSize ? 'xl' : undefined}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={() => onClose('confirmed')} color={dangerous ? 'secondary' : 'primary'} variant="contained">
            {okButtonText || 'OK'}
          </Button>
          {cancelable && <Button onClick={() => onClose('cancelled')}>Cancel</Button>}
        </DialogActions>
      </Dialog>
    );
  }
}

export default ConfirmationDialog;
